import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications'
import { useDataChange, useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  let setRefreshEvents = useDataChange({
    context: 'refresh',
    path: 'events',
    viewPath: props.viewPath,
  })

  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'treatment_card',
    path: 'txs.organization._id',
  })

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'cancel': {
        change(originalValue)
        return
      }
      default: {
        let data = []

        if (Array.isArray(value.timeline_filter_presets)) {
          data = value.timeline_filter_presets
            .filter(
              (item, index, list) =>
                index === list.findIndex(i => i.id === item.id)
            )
            .map(item => ({
              ...item,
              value: Array.isArray(args.selected)
                ? args.selected.includes(item.id)
                : false,
            }))
        }
        let response = await executeMutation({
          location_id,
          data,
        })

        if (response.error) {
          notify(
            notifyError(
              'Something went wrong. Please, try again or contact support if the problem persists.'
            )
          )
          return
        }

        setRefreshEvents(Date.now())
      }
    }
  }
}
